{
  "links": {
    "profile": "Profile",
    "profile_description": "View or edit your profile.",
    "students": "Students",
    "students_description": "View or edit your student's details and preferences .",
    "preferences": "Preference Templates",
    "preferences_description": "View, create and edit preference templates. Reuse and apply templates to multiple or individual students.",
    "relief_listings": "Relief Listings",
    "relief_listings_description": "View, create, and manage relief listings."
  }
}
